import React, { useCallback, useImperativeHandle, useMemo, useState } from "react";

import { colors } from "@zapalacorp/tokens";
import { AppViewerDrawer } from "Components/Generic/AppViewerDrawer";
import { Fleet } from "Models/fleet";
import { useTranslation } from "react-i18next";

import { AvalabilitySection } from "./sections/AvalabilitySection";
import { DetailsSection } from "./sections/DetailsSection";
import { MembersAndTeamsSection } from "./sections/MembersAndTeamsSection";
import { OrdersSection } from "./sections/OrdersSection";

export interface FleetShowDrawerHandles {
  open: (fleet: Fleet) => void;
  close: () => void;
}

export const FleetShowDrawer = React.forwardRef<FleetShowDrawerHandles, any>((_props, ref) => {
  const [isOpenFleetShowDrawer, setIsOpenFleetShowDrawer] = useState<boolean>(false);
  const [fleet, setFleet] = useState<Fleet>();
  const { t: translate } = useTranslation();

  const title = useMemo(() => {
    if (!fleet) return;

    return `${translate("view")} ‘${translate("equipment")} #${fleet.id}’`;
  }, [fleet]);

  const open = useCallback((newFleet: Fleet) => {
    setFleet(newFleet);
    setIsOpenFleetShowDrawer(true);
  }, []);

  const close = useCallback(() => {
    setIsOpenFleetShowDrawer(false);
  }, []);

  useImperativeHandle(ref, () => ({
    open,
    close,
  }));

  const sections = [
    {
      id: "details",
      title: translate("details"),
      content: fleet && <DetailsSection fleet={fleet} />,
    },
    {
      id: "availability",
      title: translate("availability"),
      content: fleet && <AvalabilitySection fleet={fleet} />,
    },
    {
      id: "members_and_teams",
      title: translate("membersAndTeams"),
      content: fleet && <MembersAndTeamsSection fleet={fleet} />,
    },
    {
      id: "orders",
      title: translate("orders"),
      content: fleet && <OrdersSection fleet={fleet} />,
    },
  ];

  return (
    <AppViewerDrawer
      DrawerProps={{
        open: isOpenFleetShowDrawer,
        onClose: () => {
          setIsOpenFleetShowDrawer(false);
        },
        sx: { color: colors.gray600 },
      }}
      title={title}
      fullHeight
      sectionItems={sections}
    />
  );
});
